import React, { useState, useEffect } from 'react';
import Navbar from '../layout/Navbar';
import Select from 'react-select';
import { decryptData } from '../../utils/encrypt';
import {
  SALES_ORDER_CREATE_ENDPOINT,
  SALES_ORDER_CUSTOMER_LIST,
  MATERIAL_LIST_ENDPOINT, SO_CREATE_WABA_ENDPOINT
} from '../../config/api';

function SalesOrderNew() {
  const [form, setForm] = useState({
    customer_id: '',
    customer_po_no: '',
    po_date: new Date().toISOString().split('T')[0],
    remark: '',
    attachments: [],
    items: [
      {
        material_id: '',
        qty: 1,
        unit: '',
        price: 0,
        gst: 0
      }
    ]
  });

  const [customers, setCustomers] = useState([]);
  const [materials, setMaterials] = useState([]);
  const [, setUser] = useState({});

  useEffect(() => {
    const encrypted = localStorage.getItem('suyog_user');
    if (encrypted) {
      const decryptedUser = decryptData(encrypted);
      setUser(decryptedUser);

      fetch(SALES_ORDER_CUSTOMER_LIST, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: decryptedUser.user_id })
      })
        .then(res => res.json())
        .then(data => Array.isArray(data) ? setCustomers(data) : setCustomers([]))
        .catch(() => setCustomers([]));
    }

    fetch(MATERIAL_LIST_ENDPOINT)
      .then(res => res.json())
      .then(data => Array.isArray(data) ? setMaterials(data) : setMaterials([]))
      .catch(() => setMaterials([]));
  }, []);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'attachments') {
      const validFiles = Array.from(files).filter(file =>
        file.type.startsWith('image/') || file.type === 'application/pdf'
      );
      setForm({ ...form, attachments: [...form.attachments, ...validFiles] });
    } else {
      setForm({ ...form, [name]: value });
    }
  };

  const removeAttachment = (index) => {
    const updatedAttachments = [...form.attachments];
    updatedAttachments.splice(index, 1);
    setForm({ ...form, attachments: updatedAttachments });
  };

  const handleItemChange = (index, field, value) => {
    const updatedItems = [...form.items];
    updatedItems[index][field] = value;

    if (field === 'material_id') {
      const selectedMaterial = materials.find(m => m.id === value);
      if (selectedMaterial) {
        updatedItems[index].unit = selectedMaterial.unit || '';
        updatedItems[index].gst = selectedMaterial.hsn_percent || 0;
      }
    }

    setForm({ ...form, items: updatedItems });
  };

  const addItem = () => {
    setForm({
      ...form,
      items: [...form.items, { material_id: '', qty: 1, unit: '', price: 0, gst: 0 }]
    });
  };

  const removeItem = (index) => {
    const updatedItems = [...form.items];
    updatedItems.splice(index, 1);
    setForm({ ...form, items: updatedItems });
  };

  const calculateTotals = (item) => {
    const total = item.qty * item.price;
    const gstTotal = (total * item.gst) / 100;
    const grandTotal = total + gstTotal;
    return { total, gstTotal, grandTotal };
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const encrypted = localStorage.getItem('suyog_user');
    const parsedUser = decryptData(encrypted);

    const org_id = parsedUser?.selected_org?.value || null;
    const user_id = parsedUser?.user_id;

    if (!user_id || !org_id) {
      alert('Missing user or organization. Please login and select organization.');
      return;
    }

    const formData = new FormData();
    formData.append('user_id', user_id);
    formData.append('org_id', org_id); // ✅ append selected org_id here

    Object.keys(form).forEach(key => {
      if (key === 'attachments') {
        form.attachments.forEach(file => formData.append('attachments[]', file));
      } else if (key === 'items') {
        formData.append('items', JSON.stringify(form.items));
      } else {
        formData.append(key, form[key]);
      }
    });

    const res = await fetch(SALES_ORDER_CREATE_ENDPOINT, {
      method: 'POST',
      body: formData
    });

    const data = await res.json();
    if (res.ok) {
      alert('Sales order created successfully');
  sendWabaNotification(data.sales_order_id, form.customer_id, 'created');



      setTimeout(() => {
  window.location.reload();
}, 5000); // 5000ms = 5 seconds
       window.location.reload(); // ✅ reloads the full form/page
    } else {
      alert(data.error || 'Failed to create sales order');
    }
  } catch (err) {
    console.error('Submit error:', err);
    alert('Server error');
  }
};

  const customerOptions = customers.map(c => ({ value: c.id, label: c.account_name }));
  const materialOptions = materials.map(m => ({ value: m.id, label: m.material_name }));

  const isFormValid = () => {
    if (!form.customer_id || !form.customer_po_no.trim()) return false;
    for (let item of form.items) {
      if (!item.material_id || item.qty <= 0 || item.price <= 0) {
        return false;
      }
    }
    return true;
  };



  async function sendWabaNotification(salesOrderId, customerId, source = 'created') {
    try {
      const res = await fetch(SO_CREATE_WABA_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          sales_order_id: salesOrderId,
          customer_id: customerId
        })
      });

      const result = await res.json();
      if (result.success) {
        console.log(`✅ WhatsApp sent (${source})`);
        if (source === 'manual') alert('WhatsApp message sent!');
      } else {
        console.warn(`⚠️ Failed to send WhatsApp (${source}):`, result.error);
        if (source === 'manual') alert('Failed to send WhatsApp');
      }
    } catch (err) {
      console.error(`❌ Error sending WhatsApp (${source}):`, err);
      if (source === 'manual') alert('Error sending WhatsApp');
    }
  }




  return (
    <>
      <Navbar />
      <div className="container mt-5">
        <div className="card shadow-lg border-0 rounded-4">
          <div className="card-header text-white rounded-top-4" style={{ background: 'linear-gradient(90deg, #007bff, #0056b3)', padding: '1rem 1.5rem' }}>
            <h4 className="mb-0">Add New Sales Order</h4>
            <small className="text-white-50">Enter customer and item details</small>
          </div>

          <div className="card-body p-4">
            <form onSubmit={handleSubmit} encType="multipart/form-data">
              <div className="row g-4 align-items-start mb-4">
                <div className="col-md-5">
                  <label className="form-label">Customer</label>
                  <Select
                    options={customerOptions}
                    value={customerOptions.find(opt => opt.value === form.customer_id) || null}
                    onChange={(selected) => setForm({ ...form, customer_id: selected ? selected.value : '' })}
                    placeholder="Select Customer..."
                    isClearable
                  />
                </div>

                <div className="col-md-7">
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label className="form-label">Customer PO No</label>
                      <input type="text" className="form-control" name="customer_po_no" value={form.customer_po_no} onChange={handleChange} />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">PO Date</label>
                      <input type="date" className="form-control" name="po_date" value={form.po_date} onChange={handleChange} />
                    </div>
                    <div className="col-12">
                      <label className="form-label">Remark</label>
                      <input type="text" className="form-control" name="remark" value={form.remark} onChange={handleChange} />
                    </div>
                    <div className="col-12">
                      <label className="form-label">PO Attachments (Images or PDFs only)</label>
                      <input type="file" name="attachments" className="form-control" accept="image/*,application/pdf" multiple onChange={handleChange} />
                      <div className="mt-2">
                        {form.attachments.map((file, index) => (
                          <div key={index} className="d-flex justify-content-between align-items-center">
                            <span>{file.name}</span>
                            <button type="button" className="btn btn-sm btn-danger" onClick={() => removeAttachment(index)}>Remove</button>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <h5 className="mt-4">Items</h5>
              {form.items.map((item, index) => {
                const { total, gstTotal, grandTotal } = calculateTotals(item);
                return (
                  <div className="row g-2 align-items-end mb-3" key={index}>
                    <div className="col-md-3">
                      <label className="form-label">Material</label>
                      <Select
                        options={materialOptions}
                        value={materialOptions.find(opt => opt.value === item.material_id) || null}
                        onChange={(selected) => handleItemChange(index, 'material_id', selected ? selected.value : '')}
                        placeholder="Select Material..."
                        isClearable
                      />
                    </div>
                    <div className="col-md-1">
                      <label className="form-label">Qty</label>
                      <input
                        type="number"
                        step="0.001"
                        min="0"
                        className="form-control"
                        value={item.qty}
                        onChange={(e) => handleItemChange(index, 'qty', parseFloat(e.target.value) || 0)}
                        required
                      />
                    </div>
                    <div className="col-md-1">
                      <label className="form-label">Unit</label>
                      <input
                        type="text"
                        className="form-control bg-dark text-white"
                        value={item.unit}
                        readOnly
                      />
                    </div>
                    <div className="col-md-2">
                      <label className="form-label">Price</label>
                      <input
                        type="number"
                        className="form-control"
                        value={item.price}
                        onChange={(e) => handleItemChange(index, 'price', parseFloat(e.target.value) || 0)}
                        required
                      />
                    </div>
                   
                    <div className="col-md-1">
                      <label className="form-label">Total</label>
                      <input className="form-control bg-dark text-white" value={total.toFixed(2)} readOnly />
                    </div>
                     <div className="col-md-1">
                      <label className="form-label">GST%</label>
                      <input
                        type="number"
                        className="form-control bg-dark text-white"
                        value={item.gst}
                        readOnly
                      />
                    </div>
                    <div className="col-md-1">
                      <label className="form-label">GST Amt</label>
                      <input className="form-control bg-dark text-white" value={gstTotal.toFixed(2)} readOnly />
                    </div>
                    <div className="col-md-1">
                      <label className="form-label">Grand Total</label>
                      <input className="form-control bg-dark text-white" value={grandTotal.toFixed(2)} readOnly />
                    </div>
                    <div className="col-md-1 text-end">
                      <label className="form-label d-block invisible">Remove</label>
                      <button hidden type="button" className="btn btn-danger w-100" onClick={() => removeItem(index)}>Remove</button>
                    </div>
                  </div>
                );
              })}

              <button  hidden type="button" className="btn btn-outline-primary mb-3" onClick={addItem}>+ Add Item</button>
              <div className="text-end">
                <button type="submit" className="btn btn-success" disabled={!isFormValid()}>Submit Order</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default SalesOrderNew;
